import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  onClick
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden ${onClick ? 'cursor-pointer hover:shadow-md transition-all duration-200' : ''} ${className}`} onClick={onClick} data-id="element-166">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: CardProps) {
  return <div className={`px-6 py-5 border-b border-gray-100 ${className}`} data-id="element-167">
      {children}
    </div>;
}
export function CardTitle({
  children,
  className = ''
}: CardProps) {
  return <h3 className={`text-lg font-semibold text-gray-900 tracking-tight ${className}`} data-id="element-168">
      {children}
    </h3>;
}
export function CardContent({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-6 ${className}`} data-id="element-169">{children}</div>;
}